


















































































































































































































































































































































































import { Component, Vue, Watch, Emit, Prop  } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
/* 画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
/* ストア、定数関連 */
import { eucUploadModule } from '../../Kanri/store/modules/EucUpload'; // アップロードファイルモジュール
import { loadingControlModule } from '../../store/modules/LoadingControl';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class FileUpload extends ApiAccessBase {
  private validate = require('../../CommonUtils/fixed/Validate'); // Validate
  private rules1: any; //DBファイル アップロード必須チェック
  private rules2: any; //SQLファイル アップロード必須チェック
  private rules3: any; //INFファイル アップロード必須チェック
  private rules4: any; //EXCELファイル アップロード必須チェック
  private rules5: any; //DBファイル ダウンロード必須チェック
  private rules6: any; //SQLファイル ダウンロード必須チェック
  private rules7: any; //INFファイル ダウンロード必須チェック
  private rules8: any; //EXCELファイル ダウンロード必須チェック
  private required1?: boolean = true;
  private required2?: boolean = true;
  private required3?: boolean = true;
  private required4?: boolean = true;
  private required5?: boolean = true;
  private required6?: boolean = true;
  private required7?: boolean = true;
  private required8?: boolean = true;
  private value?: string;
  private actionId: string = '';

  private DBLIST: any = [];
  private SQLLIST: any = [];
  private INFLIST: any = [];
  private EXCELLIST: any = [];
  private SELNAME?: string; //ダウンロードボタン押下時に対象のファイル名格納
  private SELNAME5?: string; //DBファイル 選択中ファイル名
  private SELNAME6?: string; //SQLファイル 選択中ファイル名
  private SELNAME7?: string; //INFファイル 選択中ファイル名
  private SELNAME8?: string; //EXCELファイル 選択中ファイル名
  // // axiosの共通設定
  // private axiosApi = axios.create();
  // 拡張パネルの設定
  private eucPanel: number[] = [0, 1];  //初期表示展開

  private isValidateRequiredFile1(value: any) {
    return this.validate.isValidateRequiredFile(eucUploadModule.uploadFileDb, this.required1);
  }
  private isValidateRequiredFile2(value: any) {
    return this.validate.isValidateRequiredFile(eucUploadModule.uploadFileSql, this.required2);
  }
  private isValidateRequiredFile3(value: any) {
    return this.validate.isValidateRequiredFile(eucUploadModule.uploadFileInf, this.required3);
  }
  private isValidateRequiredFile4(value: any) {
    return this.validate.isValidateRequiredFile(eucUploadModule.uploadFileExcel, this.required4);
  }
  private isValidateRequired5(value: string) {
    return this.validate.isValidateRequired(value, this.required5);
  }
  private isValidateRequired6(value: string) {
    return this.validate.isValidateRequired(value, this.required6);
  }
  private isValidateRequired7(value: string) {
    return this.validate.isValidateRequired(value, this.required7);
  }
  private isValidateRequired8(value: string) {
    return this.validate.isValidateRequired(value, this.required8);
  }
  // 画面初期化処理
  // component生成時に実行
  private created() {
    loadingControlModule.startLoading();
    eucUploadModule.moduleReset(); //必須項目チェック用にリセット
    // validationルールの設定
    this.rules1 = [
      (value: any) => (this.isValidateRequiredFile1(value)) || '必須項目です。',
      ];
    this.rules2 = [
      (value: any) => (this.isValidateRequiredFile2(value)) || '必須項目です。',
      ];
    this.rules3 = [
      (value: any) => (this.isValidateRequiredFile3(value)) || '必須項目です。',
      ];
    this.rules4 = [
      (value: any) => (this.isValidateRequiredFile4(value)) || '必須項目です。',
      ];
    this.rules5 = [
      (value: string) => (this.isValidateRequired5(value)) || '必須項目です。',
      ];
    this.rules6 = [
      (value: string) => (this.isValidateRequired6(value)) || '必須項目です。',
      ];
    this.rules7 = [
      (value: string) => (this.isValidateRequired7(value)) || '必須項目です。',
      ];
    this.rules8 = [
      (value: string) => (this.isValidateRequired8(value)) || '必須項目です。',
      ];

    const path = Constants.KANRI_URL + '/euc/filelist';
    // アップロード済ファイルアップ一覧取得
    // APIアクセス
    this.axiosApi
      .get(path)
      .then((response) => {
        this.DBLIST = response.data.entity.DBLIST;
        this.SQLLIST = response.data.entity.SQLLIST;
        this.INFLIST = response.data.entity.INFLIST;
        this.EXCELLIST = response.data.entity.EXCELLIST;
      })
      .catch((error) => {
        this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
      })
      .finally(() => {
        loadingControlModule.endLoading();
      });
  }

  private selectedFile1(e: any) {
    const files = e;
    eucUploadModule.setUploadFileDb(files[0]);
  }
  private selectedFile2(e: any) {
    const files = e;
    eucUploadModule.setUploadFileSql(files[0]);
  }
  private selectedFile3(e: any) {
    const files = e;
    eucUploadModule.setUploadFileInf(files[0]);
  }
  private selectedFile4(e: any) {
    const files = e;
    eucUploadModule.setUploadFileExcel(files[0]);
  }

  @Emit('input')
  private selectValue5(value: string) {
    this.SELNAME5 = value;
  }
  @Emit('input')
  private selectValue6(value: string) {
    this.SELNAME6 = value;
  }
  @Emit('input')
  private selectValue7(value: string) {
    this.SELNAME7 = value;
  }
  @Emit('input')
  private selectValue8(value: string) {
    this.SELNAME8 = value;
  }

　/**
　　* ファイルアップロードDB
　　*/
  private uploadDb() {
    this.actionId = 'db';
    this.required1 = true;
    this.required2 = false;
    this.required3 = false;
    this.required4 = false;
    this.upload();
  }

　/**
　　* ファイルアップロードSQL
　　*/
  private uploadSql() {
    this.actionId = 'sql';
    this.required1 = false;
    this.required2 = true;
    this.required3 = false;
    this.required4 = false;
    this.upload();
  }
　/**
　　* ファイルアップロードINF
　　*/
  private uploadInf() {
    this.actionId = 'inf';
    this.required1 = false;
    this.required2 = false;
    this.required3 = true;
    this.required4 = false;
    this.upload();
  }
　/**
　　* ファイルアップロードExcel
　　*/
  private uploadExcel() {
    this.actionId = 'excel';
    this.required1 = false;
    this.required2 = false;
    this.required3 = false;
    this.required4 = true;
    this.upload();
  }

　/**
　　* ファイルアップロード
　　*/
  private upload() {
    this.errorMessage = '';
    this.infoMessage = '';
    this.warnMessage = '';
    this.required5 = false;
    this.required6 = false;
    this.required7 = false;
    this.required8 = false;
    let path = Constants.KANRI_URL + '/euc' + '/upload';
    const formData2 = new FormData();
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    if (window.confirm(Message.I0003)) {
      loadingControlModule.startLoading();
      formData2.delete('fileUpDb'); //実体ファイル 前回情報を削除
      formData2.delete('fileUpSql'); //実体ファイル 前回情報を削除
      formData2.delete('fileUpInf'); //実体ファイル 前回情報を削除
      formData2.delete('fileUpExcel'); //実体ファイル 前回情報を削除
      formData2.delete('actionId'); //アクションID 前回情報を削除
      formData2.append('actionId', this.actionId);
      if (eucUploadModule.uploadFileDb) {
        if (eucUploadModule.uploadFileDb.name) {
          formData2.append('fileUpDb', eucUploadModule.uploadFileDb);
        }
      }
      if (eucUploadModule.uploadFileSql) {
        if (eucUploadModule.uploadFileSql.name) {
          formData2.append('fileUpSql', eucUploadModule.uploadFileSql);
        }
      }
      if (eucUploadModule.uploadFileInf) {
        if (eucUploadModule.uploadFileInf.name) {
          formData2.append('fileUpInf', eucUploadModule.uploadFileInf);
        }
      }
      if (eucUploadModule.uploadFileExcel) {
        if (eucUploadModule.uploadFileExcel.name) {
          formData2.append('fileUpExcel', eucUploadModule.uploadFileExcel);
        }
      }

      const config = {
          headers: {
              'content-type': 'multipart/form-data',
          },
      };
      this.axiosApi
          .post(path, formData2, config)
          .then((response) => {
              // response 処理
            this.errorMessage = '';

            //アップロード済ファイル 再検索
            path = Constants.KANRI_URL + '/euc/filelist';
            // アップロード済ファイルアップ一覧取得
            // APIアクセス
            this.axiosApi
              .get(path)
              .then((response2) => {
                this.DBLIST = response2.data.entity.DBLIST;
                this.SQLLIST = response2.data.entity.SQLLIST;
                this.INFLIST = response2.data.entity.INFLIST;
                this.EXCELLIST = response2.data.entity.EXCELLIST;
                // 成功
                alert(Message.I0004);
              })
              .catch((error) => {
                this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
                // 失敗
                alert(Message.E0000);
              });
          })
          .catch((error) => {
            this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
              // 失敗
            alert(Message.E0000);
           })
          .finally(() => {
            loadingControlModule.endLoading();
          });
    }
  }

  /**
　  * ファイルダウンロードDB
　  */
  private downloadDb() {
    this.actionId = 'db';
    this.SELNAME = this.SELNAME5;
    this.required5 = true;
    this.required6 = false;
    this.required7 = false;
    this.required8 = false;
    this.download();
  }

　/**
　　* ファイルダウンロードSQL
　　*/
  private downloadSql() {
    this.actionId = 'sql';
    this.SELNAME = this.SELNAME6;
    this.required5 = false;
    this.required6 = true;
    this.required7 = false;
    this.required8 = false;
    this.download();
  }
　/**
　　* ファイルダウンロードINF
　　*/
  private downloadInf() {
    this.actionId = 'inf';
    this.SELNAME = this.SELNAME7;
    this.required5 = false;
    this.required6 = false;
    this.required7 = true;
    this.required8 = false;
    this.download();
  }
　/**
　　* ファイルダウンロードExcel
　　*/
  private downloadExcel() {
    this.actionId = 'excel';
    this.SELNAME = this.SELNAME8;
    this.required5 = false;
    this.required6 = false;
    this.required7 = false;
    this.required8 = true;
    this.download();
  }

  /**
　  * ファイルダウンロード
　  */
  private async download() {
    this.errorMessage = '';
    this.infoMessage = '';
    this.warnMessage = '';
    this.required1 = false;
    this.required2 = false;
    this.required3 = false;
    this.required4 = false;
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    // if (this.errorMessage !== '') {
    //   return;
    // }
    const path = Constants.KANRI_URL + '/euc/download';
    // ボタン押下時
    if (window.confirm(Message.I0021)) {
      loadingControlModule.startLoading();
      await this.axiosApi
      .get(path, {
            responseType: 'blob',
            params: {
              downloadFileName: this.SELNAME, //ダウンロードファイル名
              actionID: this.actionId, //ダウンロードファイル種別
            },
      })
      .then((response) => {
        const blob = new Blob([response.data], { type : '*/*' });
        let filename = '';
        const disposition = response.headers['content-disposition'];
        if (disposition && disposition.indexOf('attachment') !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches !== null && matches[1]) {
              filename = decodeURI(matches[1]).replace(/['"]/g, '').replace(/[+]/g, ' '); //UTF-8のファイル名をデコード後、半角スペースが+に置換されるのをさらに置換
            }
        }
        if (window.navigator.msSaveBlob) {
          // IEとEdge
          window.navigator.msSaveBlob(blob, filename);
        } else {
          // それ以外のブラウザ
          // Blobオブジェクトを指すURLオブジェクトを作る
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        }
        // 成功
        this.errorMessage = ''; //エラーメッセージリセット
        // alert(Message.I0022);
      })
      .catch(async (error) => {
        let textError: any;
        textError = await this.onBlobHandler(error); //ダウンロード時はレスポンスタイプがblobの為エラーメッセージがそのままでは取得出来ない。非同期処理でテキストに変換
        this.errorMessage = textError.code + ':' + textError.message + '\n';
        alert(Message.E0000);
      })
      .finally(() => {
        loadingControlModule.endLoading();
      });
    }
  }

  /**
   * responseType: 'blob'で返却されたerrorからstringのメッセージを抽出
   */
  private async onBlobHandler(error: any) {
    let text: any = '';
    const result = await this.fileReader(error.response.data);
    text = result;
    return JSON.parse(text);
  }

  /**
   * 非同期にBlobをテキストとして読み込み
   */
  private fileReader(blob: any) {
    const fileReader = new FileReader();

    return new Promise((resolve: any, reject) => {
      fileReader.onerror = () => {
        fileReader.abort();
        reject();
      };

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.readAsText(blob);
    });
  }

  /**
　  * ファイル削除DB
　  */
  private deleteDb() {
    this.actionId = 'db';
    this.SELNAME = this.SELNAME5;
    this.required5 = true;
    this.required6 = false;
    this.required7 = false;
    this.required8 = false;
    this.deleteFile();
  }

　/**
　　* ファイル削除SQL
　　*/
  private deleteSql() {
    this.actionId = 'sql';
    this.SELNAME = this.SELNAME6;
    this.required5 = false;
    this.required6 = true;
    this.required7 = false;
    this.required8 = false;
    this.deleteFile();
  }
　/**
　　* ファイル削除INF
　　*/
  private deleteInf() {
    this.actionId = 'inf';
    this.SELNAME = this.SELNAME7;
    this.required5 = false;
    this.required6 = false;
    this.required7 = true;
    this.required8 = false;
    this.deleteFile();
  }
　/**
　　* ファイル削除Excel
　　*/
  private deleteExcel() {
    this.actionId = 'excel';
    this.SELNAME = this.SELNAME8;
    this.required5 = false;
    this.required6 = false;
    this.required7 = false;
    this.required8 = true;
    this.deleteFile();
  }
  /**
　  * ファイル削除
　  */
  private deleteFile() {
    this.required1 = false;
    this.required2 = false;
    this.required3 = false;
    this.required4 = false;
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    // ボタン押下時
    if (window.confirm(Message.I0029)) {
      let path = Constants.KANRI_URL + '/euc/delete';
      // APIアクセス
      this.axiosApi
        .post(path, null, {
            params: {
              downloadFileName: this.SELNAME, //ダウンロードファイル名
              actionID: this.actionId, //ダウンロードファイル種別
            },
        })
        .then((response) => {
            //アップロード済ファイル 再検索
            path = Constants.KANRI_URL + '/euc/filelist';
            // アップロード済ファイルアップ一覧取得
            // APIアクセス
            this.axiosApi
              .get(path)
              .then((response2) => {
                this.DBLIST = response2.data.entity.DBLIST;
                this.SQLLIST = response2.data.entity.SQLLIST;
                this.INFLIST = response2.data.entity.INFLIST;
                this.EXCELLIST = response2.data.entity.EXCELLIST;
                // 成功
                this.errorMessage = ''; //エラーメッセージリセット
                alert(Message.I0002);
              })
              .catch((error) => {
                this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
                // 失敗
                alert(Message.E0000);
              });
        })
        .catch((error) => {
          this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
      })
      .finally(() => {
        loadingControlModule.endLoading();
      });
    }
  }
}
